module.exports = __webpack_public_path__ + "static/media/34_B.1936f26e.png";